<!--表单页面拷贝开始-->
<template>
    <div>
      <form-components @submitForm="submitForm">
        <template v-slot:content>
          <el-form-item label="所属项目" >
              <el-col :span="8">
                <el-input v-model="project.name" :readonly="true"></el-input>
              </el-col>
            </el-form-item>
          <el-form-item label="用例名称" >
              <el-col :span="8">
                <el-input v-model="sysAutoTestCase.name" ></el-input>
              </el-col>
            </el-form-item>

          <el-form-item label="用例代码" >
              <el-col :span="8">
                <el-input v-model="sysAutoTestCase.code" ></el-input>
              </el-col>
            </el-form-item>

          <el-form-item label="token操作" >
              <el-col :span="8">
                <el-select v-model="sysAutoTestCase.tokenOpt" style="margin-right: 20px">
                  <el-option
                    v-for="item in tokenOpt"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="默认执行" >
              <el-col :span="8">
                <el-select v-model="sysAutoTestCase.isDefault" style="margin-right: 20px">
                  <el-option
                    v-for="item in defaultOpt"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item label="排序" >
              <el-col :span="8">
                <el-input v-model="sysAutoTestCase.sort" ></el-input>
              </el-col>
            </el-form-item>

        </template>
      </form-components>
    </div>
  </template>
  
  <script>
  import FormComponents from "@/components/form/FormComponents";
  import SysAutoTestCaseApi from '@/api/SysAutoTestCaseApi'
  import { navTo,queryParam } from "@/utils/NavigatorUtils";
  export default {
    name: "SaveSysAutoTestCasePage",
    props: {
      msg: String,
    },
    components: {
      FormComponents
    },
    data() {
      return {
        sysAutoTestCase:{
          name:"",
          code:"",
          objId:0,
        },
        project:{},
        tokenOpt: [
        {
          value: "no",
          label: "不需要token",
        },
        {
          value: "read",
          label: "读取token",
        },
        {
          value: "save",
          label: "保存token",
        },
      ],defaultOpt: [
        {
          value: "no",
          label: "不执行",
        },
        {
          value: "yes",
          label: "执行",
        }
      ],
        plateform: [
        {
          value: "android",
          label: "Android",
        },
        {
          value: "ios",
          label: "IOS",
        },
        {
          value: "web",
          label: "WEB",
        },
        {
          value: "weapp",
          label: "微信小程序",
        },
        {
          value: "H5",
          label: "微信小程序",
        },
      ],
      }
    },
    created(){
      this.project = this.$route.params.project;
      this.sysAutoTestCase = this.$route.params.data;
      this.sysAutoTestCase.objId = this.project.id;
    },
    methods:{
      submitForm(){
        this.sysAutoTestCase.id>0?this.updateSysAutoTestCaseById():this.addSysAutoTestCase()
      },
      addSysAutoTestCase(){
        SysAutoTestCaseApi.saveSysAutoTestCase(this.sysAutoTestCase).then((resp)=>{
          if(resp.state=="OK"){
            this.sysAutoTestCase={}
            this.$successMsg(resp.msg)
           
          }else{
            this.$errorMsg(resp.msg)
          }
        })
      },
      updateSysAutoTestCaseById(){
        SysAutoTestCaseApi.updateSysAutoTestCase(this.sysAutoTestCase).then((resp)=>{
          if(resp.state=="OK"){
            this.user={}
            this.$successMsg(resp.msg);
            queryParam(this,'sysAutoTestCaseList',{project:this.project})
          }else{
            this.$errorMsg(resp.msg)
          }
        })
      }
    }
  };
  </script>
  
  
  <!--表单页面拷贝结束-->